const routes = [
    {
        path: '/area_cliente/login',
        component: () => import('../views/Login'),
        meta: {
            public: true
        },
        children: [
            {
                public: true,
                path: '/area_cliente/clientes/login',
                component: () => import('../views/Login'),
            }
        ]
    },
    {
        meta: { public: true },
        path: '/area_cliente/esqueci_minha_senha',
        component: () => import('../views/EsqueciSenha'),
    },
    {
        meta: { public: true },
        path: '/area_cliente/cadastrar_senha/:hash?',
        component: () => import('../views/CadastrarSenha'),
    },
    {
        meta: { public: true },
        path: '/area_cliente/cadastrar_dados/:hash',
        component: () => import('../views/CadastrarDados'),
    },
    // GCK-20830: o dashboard tem o shell próprio do portal (PortalLayout) —
    // fora do layout AdminLTE.
    {
        path: '/area_cliente',
        component: () => import('../views/Inicio'),
    },
    {
        path: '/area_cliente/inicio',
        alias: ['/area_cliente/inicio', '/area_cliente/clientes/inicio', '/area_cliente/sistema/inicio'],
        component: () => import('../views/Inicio'),
    },
    // GCK-20834: meu perfil em leitura, no shell próprio do portal
    {
        path: '/area_cliente/meu_perfil',
        component: () => import('../views/MeuPerfil'),
    }
]

export default routes
